import {
  RefObject,
  useCallback,
  useLayoutEffect,
  useRef,
  useState,
} from "react";

import { GridApiPro, GridInitialState } from "@mui/x-data-grid-pro";

interface UseGridStatePersistenceProps {
  storageKey: string;
  apiRef: RefObject<GridApiPro | null>;
}

export const useGridStatePersistence = ({
  storageKey,
  apiRef,
}: UseGridStatePersistenceProps) => {
  const hasInitialized = useRef(false);
  const [initialState, setInitialState] = useState<GridInitialState>();

  const saveSnapshot = useCallback(() => {
    if (apiRef?.current?.exportState && localStorage) {
      const currentState = apiRef.current.exportState();

      localStorage.setItem(storageKey, JSON.stringify(currentState));
    }
  }, [apiRef, storageKey]);

  useLayoutEffect(() => {
    const stateFromLocalStorage = localStorage?.getItem(storageKey);

    if (!hasInitialized.current) {
      setInitialState(
        stateFromLocalStorage ? JSON.parse(stateFromLocalStorage) : {}
      );
      hasInitialized.current = true;
    }

    window.addEventListener("beforeunload", saveSnapshot);

    return () => {
      window.removeEventListener("beforeunload", saveSnapshot);
      saveSnapshot();
    };
  }, [saveSnapshot, storageKey]);

  return { initialState, saveSnapshot };
};
